import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@material-ui/core'
import React from 'react'
import { useRecoilValue } from 'recoil'
import { gregorianToJalali, thousandsSeparate, toFarsiDigits } from '../../assets/utils'
import { summaryState } from '../../pages/contractor/atoms'

const renderConsultant = (consultant) => {
  if (!consultant) return '—'
  if (typeof consultant === 'number' || typeof consultant === 'string') {
    return `شناسه: ${toFarsiDigits(consultant)}`
  }
  const name = consultant.name ?? consultant?.user?.username ?? 'نامشخص'
  const meli = consultant.national_code ?? consultant?.nationalCode ?? consultant?.meli_code ?? '—'
  const mobile = consultant.mobile ?? consultant?.Mobile ?? consultant?.phone ?? '—'
  return `${toFarsiDigits(name)}`
}

const renderSupervisor = (supervisor) => {
  if (!supervisor) return '—'
  if (typeof supervisor === 'number' || typeof supervisor === 'string') {
    return `شناسه: ${toFarsiDigits(supervisor)}`
  }
  const name = supervisor.SupervisorName ?? supervisor.name ?? supervisor?.user?.username ?? 'نامشخص'
  const meli = supervisor.SupervisorMeliCode ?? supervisor.national_code ?? '—'
  const mobile = supervisor.SupervisorMobile ?? supervisor.mobile ?? '—'
  return `${toFarsiDigits(name)}`
}

const ContractSummary = () => {
  const summary = useRecoilValue(summaryState)
  if (!summary) return null

  return (
    <>
      <Typography component="div">
        <ul>
          <li>از مانده پرداخت نشده، کسورات قانونی (بیمه و سپرده) کسر نشده است.</li>
          <li>مالیات بر ارزش افزوده در خلاصه قرارداد منظور نشده است.</li>
        </ul>
      </Typography>

      <TableContainer elevation={5} component={Paper} style={{ maxHeight: '450px' }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell align='center'><strong>سازمان طرف قرارداد</strong></TableCell>
              <TableCell align='center'><strong>شماره</strong></TableCell>
              <TableCell align='center'><strong>تاریخ</strong></TableCell>
              <TableCell align='center'><strong>موضوع</strong></TableCell>
              <TableCell align='center'><strong>مشاور</strong></TableCell>
              <TableCell align='center'><strong>ناظر</strong></TableCell>
              <TableCell align='center'><strong>مبلغ اولیه قرارداد</strong></TableCell>
              <TableCell align='center'><strong>افزایش/کاهش</strong></TableCell>
              <TableCell align='center'><strong>مبلغ قرارداد</strong></TableCell>
              <TableCell align='center'><strong>جمع صورت وضعیت های کارکرد</strong></TableCell>
              <TableCell align='center'><strong>مانده صورت وضعیت نشده</strong></TableCell>
              <TableCell align='center'><strong>سایر صورت وضعیت ها</strong></TableCell>
              <TableCell align='center'><strong>جمع صورت وضعیت</strong></TableCell>
              <TableCell align='center'><strong>پرداخت شده</strong></TableCell>
              <TableCell align='center'><strong>مانده پرداخت نشده</strong></TableCell>
              <TableCell align='center'><strong>بدهی پیش پرداخت جاری</strong></TableCell>
              <TableCell align='center'><strong>بدهی پیش پرداخت سنواتی</strong></TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            <TableRow key={summary.id ?? 'summary-row'}>
              <TableCell align='center'>{toFarsiDigits(summary.contractee)}</TableCell>
              <TableCell align='center'>{toFarsiDigits(summary.number)}</TableCell>
              <TableCell align='center'>{gregorianToJalali(summary.date)}</TableCell>
              <TableCell align='center'>{toFarsiDigits(summary.subject ? summary.subject : 'نامشخص')}</TableCell>
              <TableCell align='center'>{renderConsultant(summary.consultant)}</TableCell>
              <TableCell align='center'>{renderSupervisor(summary.supervisor)}</TableCell>
              <TableCell align='center'>{toFarsiDigits(thousandsSeparate(summary.contract_cost))}</TableCell>
              <TableCell align='center'>{toFarsiDigits(thousandsSeparate(summary.increase_decrease_cost || 0))}</TableCell>
              <TableCell align='center'>{toFarsiDigits(thousandsSeparate(summary.contract_total ?? (Number(summary.contract_cost || 0) + Number(summary.increase_decrease_cost || 0))))}</TableCell>
              <TableCell align='center'>{toFarsiDigits(thousandsSeparate(summary.request_sum))}</TableCell>
              <TableCell align='center'>{toFarsiDigits(thousandsSeparate(summary.request_remaining))}</TableCell>
              <TableCell align='center'>{toFarsiDigits(thousandsSeparate(summary.extra_request_amount))}</TableCell>
              <TableCell align='center'>{toFarsiDigits(thousandsSeparate(summary.sum_request_amount))}</TableCell>
              <TableCell align='center'>{toFarsiDigits(thousandsSeparate(summary.paid))}</TableCell>
              <TableCell align='center'>{toFarsiDigits(thousandsSeparate(summary.remaining_payment))}</TableCell>
              <TableCell align='center'>{toFarsiDigits(thousandsSeparate(summary.prepayment_debt))}</TableCell>
              <TableCell align='center'>{toFarsiDigits(thousandsSeparate(summary.old_years_prepayment_debt))}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}

export default ContractSummary
